export const config = {
  moduleName: "rozkopavky",
  moduleNameCamelCase: "Rozkopavky",
  type: "rozkopavky",

  mainFileName: "Rozkopavky.svelte",

  texts: {
    title: "Rozkopávky",
    dialog: {
      title: "Máte aktívnu editáciu rozkopávky.",
      text: "Zrušením editácie ostane rozkopávka nezmenená.\n Chcete editáciu zrušiť?",
      confirm: "Áno, zrušiť editáciu",
      cancel: "Nie, pokračovať v editovaní",
    },
    editPovodneKreslenia:
      "Jedno alebo viac kreslení, ktoré boli súčasťou editovanej rozkopávky, nie je teraz zvolené. Chcete uložiť rozkopávku s aktuálne zvolenými kresleniami?",
    pridat: "Pridať rozkopávku",
    zobrazit: "Zobraziť rozkopávku",
    dialogZmazat: {
      title: "Určite chcete zmazať túto rozkopávku?",
      text: "Ak má rozkopávka viac geometrií, budú zmazané aj tie. Táto akcia sa nedá vrátiť.",
      confirm: "Áno",
      cancel: "Zrušiť",
    },
    formTitle: "Nová rozkopávka",
  },
};
